/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'setting': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<defs><path pid="0" id="svgicon_setting_a" d="M0 0h20v20H0z"/></defs><g _fill="none" fill-rule="evenodd"><mask id="svgicon_setting_b" _fill="#fff"><use xlink:href="#svgicon_setting_a"/></mask><path pid="1" _stroke="currentColor" stroke-width="1.2" stroke-linejoin="round" mask="url(#svgicon_setting_b)" transform="rotate(-30 10.032 10.166)" d="M10.032 2.114l6.974 4.026v8.053l-6.974 4.026-6.973-4.026V6.14z"/><circle pid="2" _stroke="currentColor" stroke-width="1.2" stroke-linejoin="round" mask="url(#svgicon_setting_b)" cx="10.032" cy="10.166" r="2.75"/></g>'
  }
})
